import { Check } from "lucide-react";
import { Sparkle, Bone, Squiggle } from "./Decorations";

const CREDS = [
  ["Georgetown University", "Undergraduate Degree"],
  ["Drexel University College of Medicine", "Medical School"],
  ["Yale-New Haven Hospital", "Internal Medicine Residency"],
  ["NYU / Hospital for Joint Diseases", "Rheumatology Fellowship"],
  ["Board Certification", "Rheumatology"],
  ["American College of Rheumatology", "FACR"],
];

export default function Career() {
  return (
    <section
      id="career"
      data-testid="career-section"
      className="relative py-28 bg-lavender-bg overflow-hidden"
    >
      <Bone className="absolute top-16 right-10 opacity-25 hidden lg:block" size={70} />
      <Sparkle className="absolute bottom-16 left-12" color="#6F2DA8" size={22} />

      <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 reveal-left">
          <p className="pill mb-5 reveal">Training &amp; Credentials</p>
          <h2
            className="h-display text-3xl sm:text-4xl title-underline reveal"
            data-testid="career-title"
          >
            Dr. Maggie's Career
          </h2>
          <div className="mt-3 max-w-[200px]">
            <Squiggle className="w-full h-4 opacity-70" color="#8E44AD" />
          </div>
          <p className="mt-8 text-[16px] leading-relaxed text-charcoal/85 reveal">
            Dr. Maggie is a board-certified rheumatologist. She earned her undergraduate degree at
            Georgetown University, attended medical school at Drexel University College of
            Medicine, completed internal medicine residency at Yale-New Haven Hospital, and
            completed rheumatology fellowship at NYU / Hospital for Joint Diseases.
          </p>
          <p className="mt-4 text-[16px] leading-relaxed text-charcoal/85 reveal">
            Her career has focused on rheumatology, arthritis awareness, autoimmune disease
            education, lupus awareness, women's health, minority health, patient advocacy, and
            community outreach.
          </p>
        </div>

        <div className="lg:col-span-7">
          <ol
            data-testid="career-timeline"
            className="relative border-l-2 border-lavender/70 space-y-5 pl-6 lg:pl-10"
            aria-label="Education and certifications"
          >
            {CREDS.map(([title, sub], i) => (
              <li
                key={title}
                className="relative reveal-right"
                style={{ transitionDelay: `${i * 110}ms` }}
              >
                <span className="absolute -left-[34px] lg:-left-[46px] top-2 h-7 w-7 rounded-full bg-white border-2 border-royal grid place-items-center shadow-[0_8px_18px_-10px_rgba(111,45,168,0.6)] hover:scale-110 transition-transform duration-300">
                  <Check size={13} className="text-royal" strokeWidth={2.5} />
                </span>
                <div className="bg-white rounded-2xl p-5 lg:p-6 border border-lavender/60 shadow-[0_14px_30px_-26px_rgba(75,31,99,0.4)] hover:border-royal transition-colors">
                  <div className="font-display text-[13px] tracking-[0.18em] uppercase text-plum">
                    {title}
                  </div>
                  <div className="mt-1 text-charcoal/75 text-[15px]">{sub}</div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
